// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FFCW","newExpiryDate":"styles_newExpiryDate__3Q51L","footer":"styles_footer__3W8NB"};